import React from 'react';
import { Dialog, DialogType } from '@fluentui/react/lib/Dialog';
import styles from './BrokerOverlay.module.scss';
import { useGetBrokersListStats } from '../BrokerHealthStatusGadget';
import HealthStatusWithText from '../../HealthStatus/HealthStatusWithText';
import { useSelector } from 'react-redux';
import { getHealthStatusOrderApis } from '../../../store/getters/health-status';

function CreateGadget({ brokers }) {
  return (
    <div className={`${styles.CreateGadget} BrokerOverlayCreateGadget`}>
      {brokers.map(({ status = '', id = '' }) => (
        <HealthStatusWithText status={status} baseLabel={id} key={id} />
      ))}
    </div>
  );
}

function BrokerOverlay({ open = false, onDismiss = () => {} }) {
  const healthStatusOrderApis = useSelector(getHealthStatusOrderApis) || [];
  const { brokersGreen, brokersRed, brokersOrange, brokersGrey } =
    useGetBrokersListStats();

  return (
    <Dialog
      hidden={!open}
      onDismiss={onDismiss}
      modalProps={{
        isBlocking: false,
        containerClassName: styles.BrokerOverlayModalContainer,
      }}
      dialogContentProps={{
        type: DialogType.close,
        title: `Broker Health (${healthStatusOrderApis.length})`,
      }}
    >
      <div className={`${styles.BrokerOverlay} BrokerOverlay`}>
        <CreateGadget brokers={brokersRed} color="RED" />
        <CreateGadget brokers={brokersOrange} color="ORANGE" />
        <CreateGadget brokers={brokersGrey} color="GREY" />
        <CreateGadget brokers={brokersGreen} color="GREEN" />
      </div>
    </Dialog>
  );
}

export default BrokerOverlay;
